import { SignupEmbedder, SignupEmbedderOptions } from 'signup-embedder';
import UsageTrackerContainer from './UsageTrackingContainer';
import AnonymousUsageTrackerContainer from './AnonymousUsageTrackerContainer';
import { executeCallbackIfEmailSubmittedAndCookiesAccepted } from '../flow-management/checkForEmailUtils';
import { isPostVerification } from '../flow-settings/settingsSelectors';
import { hasAnonQueryParam, scrubUuidFromUrl } from './uuidUtils';
import { getIsAuthInitialized, checkIsAuthed } from '../store/auth/selectors';
import { getIsNewUser, getIsNewPortalCreated, getIsExistingUserSession } from '../store/app/selectors';

const addEmailToTracker = (action, store) => {
  executeCallbackIfEmailSubmittedAndCookiesAccepted(store.getState(), action, email => {
    UsageTrackerContainer.setProperties({
      email
    });
    UsageTrackerContainer.enableTrackingByEmailConsent(email);
  });
};

const enableTracking = store => {
  const state = store.getState();
  const isNewUser = getIsNewUser(state);
  const isNewPortal = getIsNewPortalCreated(state);
  const isExistingUserSession = getIsExistingUserSession(state);

  if (isNewUser && !isNewPortal && !AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    AnonymousUsageTrackerContainer.enableNonIdentifiableTracking();
    UsageTrackerContainer.identifiableTrackingEnabled = false;
  }

  if (!isNewUser && isExistingUserSession && AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled = false;
    UsageTrackerContainer.identifiableTrackingEnabled = true;
    scrubUuidFromUrl();
  }

  if (UsageTrackerContainer.identifiableTrackingEnabled || AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    return;
  }

  const shouldOverrideTrackingWithAuth = isPostVerification() ? checkIsAuthed(state) && !hasAnonQueryParam() : checkIsAuthed(state);
  const shouldTrack = getIsAuthInitialized(state) && !shouldOverrideTrackingWithAuth;

  if (shouldTrack) {
    AnonymousUsageTrackerContainer.enableNonIdentifiableTracking();
  }
};

const enableTrackingByDeviceId = () => {
  if (AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    return;
  } // This is for embedded instances only:
  // The UTK acquision don't work on embedded instances because of cross-domain
  // limitations so we need to simulate a UUID to be able to track user correctly
  // inside a iframed signup instance.


  if (SignupEmbedder.isEmbedded()) {
    const deviceId = SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_DEVIDE_ID_OVERRIDE_OPTION);

    if (deviceId) {
      AnonymousUsageTrackerContainer.enableTrackingByDeviceIdEmbedded(deviceId);
    }
  }
};
/**
 * @description Middleware to drain the tracking event queue if
 * - The user accepts the cookie banner
 * - The user provides their email through the form, or through google
 */


export const TrackingQueueDrainingMiddleware = store => next => action => {
  enableTrackingByDeviceId();
  addEmailToTracker(action, store);
  enableTracking(store);
  return next(action);
};